import api from './api';

/* =========================
   USER PREFERENCES (DREAM HOME)
========================= */

/**
 * Fetch user preference profile (Dream Home settings)
 */
export const fetchPreferences = async () => {

  const response = await api.get(
    '/users/me/preferences/'
  );

  return response.data;
};

/**
 * Create or update user preferences
 */
export const savePreferences = async (payload) => {

  const response = await api.put(
    '/users/me/preferences/',
    payload
  );

  return response.data;
};

/**
 * Patch partial preferences update
 */
export const updatePreferencesPartial = async (
  payload
) => {

  const response = await api.patch(
    '/users/me/preferences/',
    payload
  );

  return response.data;
};

/* =========================
   AI MATCHING INTERFACE
========================= */

/**
 * Get AI-matched properties based on preferences
 * (core of recommendation engine)
 */
export const fetchMatchedProperties = async () => {

  const response = await api.get(
    '/users/me/matches/'
  );

  return response.data;
};

/**
 * Recalculate matches (trigger AI recomputation)
 */
export const refreshMatches = async () => {

  const response = await api.post(
    '/users/me/matches/recalculate/'
  );

  return response.data;
};

/* =========================
   PREFERENCE INSIGHTS (ANALYTICS)
========================= */

/**
 * Get preference analytics (what user tends to like)
 */
export const fetchPreferenceInsights = async () => {

  const response = await api.get(
    '/users/me/preferences/insights/'
  );

  return response.data;
};

/**
 * Get similarity score between user & property
 */
export const getPropertyMatchScore = async (
  propertyId
) => {

  const response = await api.get(
    `/properties/${propertyId}/match-score/`
  );

  return response.data;
};